import { assign, setup } from 'xstate'

// ─── Types ──────────────────────────────────────────────────────────────────

export interface AppMachineContext {
  locale: string
  locales: string[]
}

export type AppMachineEvents = { type: 'SET_LANGUAGE'; lang: string }

export interface AppMachineInput {
  initialLocale: string
  locales: string[]
}

// ─── Machine Definition ────────────────────────────────────────────────────

export const appMachine = setup({
  types: {
    context: {} as AppMachineContext,
    events: {} as AppMachineEvents,
    input: {} as AppMachineInput,
  },

  actions: {
    assignLocale: assign({
      locale: (_, params: { lang: string }) => params.lang,
    }),
    persistState: () => {
      /* overridden via .provide() */
    },
    changeLanguage: (_: unknown, _params: { lang: string }) => {
      /* overridden via .provide() */
    },
  },
}).createMachine({
  id: 'app',
  context: ({ input }) => ({
    locale: input.initialLocale,
    locales: input.locales,
  }),
  initial: 'ready',
  states: {
    ready: {
      on: {
        SET_LANGUAGE: {
          actions: [{ type: 'assignLocale', params: ({ event }) => ({ lang: event.lang }) }, { type: 'changeLanguage', params: ({ event }) => ({ lang: event.lang }) }, 'persistState'],
        },
      },
    },
  },
})
